module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-1.7e749303.jpg";